/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/require-await */
import * as Cesium from "cesium";
import { FileStateEnum, SeaSurveyListDto } from "~/api/GeneratedApi";
import { CesiumMeasurementItem } from "../types/CesiumMapItems";
import { seaSurveyToCesiumMapItem } from "./dataConverters";

export async function measurementInfoToCesium(
  viewer: Cesium.Viewer,
  measurements: SeaSurveyListDto[],
): Promise<void> {
  const pinBuilder = new Cesium.PinBuilder();

  // First get the heights for each measurement
  // const positions = await Cesium.sampleTerrainMostDetailed(
  //   viewer.terrainProvider,
  //   measurements.map(
  //     (m) =>
  //       new Cesium.Cartographic(
  //         Cesium.Math.toRadians(m.center.x),
  //         Cesium.Math.toRadians(m.center.y),
  //       ),
  //   ),
  // );
  measurements.forEach((m) => {
    // Convert to internal type
    const convertedMeas: CesiumMeasurementItem = seaSurveyToCesiumMapItem(m);
    // All files should be processed before adding to map
    if (
      !convertedMeas.files?.every(
        (f) => f.queuedFile?.stateId === FileStateEnum.Done,
      )
    ) {
      return;
    }
    // Use first file for location marker, in the future will use dwg file center
    const firstFile = convertedMeas?.files?.[0];
    if (!firstFile?.information) return;
    const { extentCenterXCarto, extentCenterYCarto } = firstFile?.information;

    // const carto = Cesium.Cartographic.fromCartesian(
    //   new Cesium.Cartesian3(
    //     extentCenterX,
    //     extentCenterY,
    //     minZ + (maxZ - minZ) / 2,
    //   ),
    // );
    // carto.height = 0;
    // const carto = positions[i];
    const carto = new Cesium.Cartographic(
      Cesium.Math.toRadians(extentCenterXCarto),
      Cesium.Math.toRadians(extentCenterYCarto),
    );

    // Update or add
    const entity = viewer.entities.getById(convertedMeas.mapId);
    if (entity) {
      entity.name = convertedMeas.name;
      entity.position = new Cesium.ConstantPositionProperty(
        Cesium.Ellipsoid.WGS84.cartographicToCartesian(carto),
      );
      entity.properties = new Cesium.PropertyBag({
        ...convertedMeas,
      });
    } else {
      viewer.entities.add({
        name: convertedMeas.name,
        id: convertedMeas.mapId,
        position: Cesium.Ellipsoid.WGS84.cartographicToCartesian(carto),
        properties: new Cesium.PropertyBag({
          ...convertedMeas,
        }),
        billboard: {
          image: pinBuilder.fromColor(Cesium.Color.ROYALBLUE, 48).toDataURL(),
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND, // Breaks camera zoom, keep disabled
        },
      });
    }
  });
}
